(function () {
  /* Mobile gallery: thumbnails and a counter that follow the swipe */
  var col = document.querySelector('.ws-galcol.is-carousel');
  if (!col) return;
  var track = col.querySelector('.ws-mtrack');
  var thumbs = col.querySelectorAll('[data-ws-thumb]');
  var fig = col.querySelector('figure');
  if (!track || !thumbs.length) return;
  var count = document.createElement('span'); count.className = 'ws-gcount'; count.setAttribute('aria-hidden', 'true');
  fig.appendChild(count);
  function set(i) {
    thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); t.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
    count.textContent = (i + 1) + ' / ' + thumbs.length;
    var t = thumbs[i], strip = t.parentNode;
    var x = strip.scrollLeft + (t.getBoundingClientRect().left - strip.getBoundingClientRect().left) - (strip.clientWidth - t.offsetWidth) / 2;
    strip.scrollTo({ left: x, behavior: 'smooth' });
  }
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function (e) {
      if (!window.matchMedia('(max-width: 760px)').matches) return;
      e.preventDefault(); e.stopImmediatePropagation();
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }, true);
  });
  var last = -1;
  function onScroll() { var w = track.clientWidth; if (!w) return; var i = Math.max(0, Math.min(thumbs.length - 1, Math.round(track.scrollLeft / w))); if (i !== last) { last = i; set(i); } }
  track.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
(function () {
  /* Guarantee seal on the main image */
  var fig = document.querySelector('.ws-galcol figure');
  var gEl = document.querySelector('[data-ws-gdays]');
  var g = gEl ? gEl.getAttribute('data-ws-gdays') : '';
  if (fig && g && +g > 0 && !fig.querySelector('.ws-seal')) {
    var seal = document.createElement('span'); seal.className = 'ws-seal'; seal.setAttribute('aria-hidden', 'true');
    seal.innerHTML = '<strong>' + g + '</strong><span>day money-back guarantee</span>';
    fig.appendChild(seal);
  }
  /* Bundle rows: radio, total price and saving */
  var json = document.querySelector('[data-ws-json]');
  if (!json) return;
  var data; try { data = JSON.parse(json.textContent); } catch (e) { return; }
  var one = data.variants[0]; if (!one) return;
  function money(c) { return '£' + (c / 100).toFixed(2); }
  document.querySelectorAll('[data-ws-bundle]').forEach(function (b, i) {
    var v = data.variants[i]; if (!v || b.querySelector('.ws-b__p')) return;
    var spans = b.querySelectorAll(':scope > span:not(.ws-badge)');
    if (spans[0]) spans[0].classList.add('ws-b__t');
    if (spans[1]) spans[1].classList.add('ws-b__n');
    var full = one.price * v.qty, save = full - v.price;
    var r = document.createElement('span'); r.className = 'ws-b__radio'; r.setAttribute('aria-hidden', 'true');
    b.insertBefore(r, spans[0] || null);
    if (save > 0 && spans[0]) { var em = document.createElement('em'); em.className = 'ws-b__save'; em.textContent = 'Save ' + money(save); spans[0].appendChild(document.createTextNode(' ')); spans[0].appendChild(em); }
    var p = document.createElement('span'); p.className = 'ws-b__p'; p.setAttribute('aria-hidden', 'true');
    p.innerHTML = '<strong>' + money(v.price) + '</strong>' + (save > 0 ? '<s>' + money(full) + '</s>' : '');
    b.appendChild(p);
  });
})();